import { PropsWithChildren } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { IconButton } from '@ravago/shared/radiance/components/button/components/IconButton/IconButton';
import { Expand } from '@ravago/shared/radiance/components/expand/components/Expand/Expand';
import { Paper } from '@ravago/shared/radiance/components/paper/components/Paper/Paper';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props extends PropsWithChildren {
   title: string;
   expanded: boolean;
   expandable?: boolean;
   onExpandToggle: () => void;
}

export const RequestForQuotationDesktop = ({ title, expanded, onExpandToggle, expandable = true, children }: Props) => {
   const translate = useTranslations();

   return (
      <Paper border={false} shadow>
         <Box direction="column" spacing={{ x: 'sm', y: 'sm' }}>
            <Expand
               expanded={expanded}
               header={
                  <Box justify="between" direction="row" items="center" spacing={{ bottom: expanded ? 'md' : 'none' }}>
                     <Typography component="h4" variant="heading-4" color="strong">
                        {translate(title)}
                     </Typography>
                     {expandable && (
                        <IconButton
                           onClick={onExpandToggle}
                           ariaLabel={expanded ? 'collapse' : 'expand'}
                           icon={expanded ? 'chevron-up' : 'chevron-down'}
                        />
                     )}
                  </Box>
               }
               keepMounted
            >
               {children}
            </Expand>
         </Box>
      </Paper>
   );
};
